import React, { useState, useEffect } from 'react';
import { addAllFacebookParamsToUrl } from '../../../utils/trackingParams';
import { useAssessment } from '../../../components/navigation/AssessmentStateManager';

const StickyCTA = () => {
  const { state } = useAssessment();
  const [challengeUrl, setChallengeUrl] = useState('https://limitlessmen.com/masterclass-room?utm_source=assessment');

  useEffect(() => {
    // Add fbclid and email to URL if available
    const baseUrl = 'https://limitlessmen.com/masterclass-room?utm_source=assessment';
    const emailParam = state?.email ? `&email=${encodeURIComponent(state?.email)}` : '';
    const fullUrl = `${baseUrl}${emailParam}`;
    const urlWithTracking = addAllFacebookParamsToUrl(fullUrl);
    setChallengeUrl(urlWithTracking);
  }, [state?.email]);

  const handleChallengeClick = () => {
    const baseUrl = 'https://limitlessmen.com/masterclass-room?utm_source=assessment';
    const emailParam = state?.email ? `&email=${encodeURIComponent(state?.email)}` : '';
    const challengeUrl = `${baseUrl}${emailParam}`;
    const urlWithTracking = addAllFacebookParamsToUrl(challengeUrl);
    window.location.href = urlWithTracking;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-brand-gold to-yellow-600 shadow-2xl">
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8 py-4 md:py-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-brand-black font-bold text-base md:text-lg text-center md:text-left">
            You've seen the pattern. Ready to break it?
          </p>
          <a
            href={challengeUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleChallengeClick}
            className="inline-flex items-center gap-2 px-6 md:px-8 py-3 bg-brand-black text-brand-gold font-bold text-sm md:text-base rounded-md hover:bg-gray-900 transition-colors duration-200 whitespace-nowrap shadow-lg"
          >
            WATCH THE MASTERCLASS
            <span className="text-lg">→</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;